export default "__VITE_ASSET__7b8279ba__"